import React from "react";
import styles from "../NavigationMenu.module.scss";
import titleStyles from "./NavigationParentItem.module.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Link} from "react-router-dom";
import Badge from "@/components/Global/Badge/Badge";
import RenderIf from "@/components/Global/RenderIf/RenderIf";
import {faChevronRight} from "@fortawesome/pro-regular-svg-icons/faChevronRight";
import {faExclamation} from "@fortawesome/pro-solid-svg-icons/faExclamation";

export default function NavigationParentItem({path, title, icon, description, displayBadge, onButtonClick}) {
  const wrapperClasses = `row mx-0 align-items-center ${styles.navItem}`;

  const contents = (
    <>
      <div className={`col-auto ${styles.navItemIcon}`}>
        <FontAwesomeIcon icon={icon} size="xl" className="fa-fw" />
      </div>
      <div className="col d-flex flex-column flex-grow-1">
        <span className={titleStyles.navItemTitle}>{title}</span>
        <span className={styles.navItemDesc}>{description}</span>
      </div>
      <RenderIf isTrue={displayBadge}>
        <Badge variant="danger" size="md" className={`rounded-circle p-0 ${styles.badge}`} pillShape={false}>
          <FontAwesomeIcon icon={faExclamation} size="xs" />
        </Badge>
      </RenderIf>
      <div className={`col-auto ${styles.navItemChevron}`}>
        <FontAwesomeIcon icon={faChevronRight} size="xl" />
      </div>
    </>
  );

  if (typeof onButtonClick === "function") {
    return (
      <li className={`list-group-item ${titleStyles.border} px-0 py-3 rounded-0`} onClick={onButtonClick}>
        <div className={wrapperClasses} role="button" tabIndex={0}>
          {contents}
        </div>
      </li>
    );
  }

  return (
    <li className={`list-group-item ${titleStyles.border} p-0 rounded-0`}>
      <Link className={`${wrapperClasses} px-0 py-3`} to={path}>
        {contents}
      </Link>
    </li>
  );
}
